<template>
  <div class="tw-flex tw-flex-col">
    <div
      v-if="!props.skipSLA && (!useUserConfigStore().userData.remoteControlTOTP || !useUserConfigStore().userData.remoteControlSLA)"
      class="tw-flex tw-flex-row tw-items-center tw-justify-center tw-p-8">
      <div>
        <RoundIconButton
          v-if="useUserConfigStore().userData.remoteControlSLA"
          fa-icon="check"
          variant="statusGreen"
          disabled />
        <RoundIconButton
          v-else
          fa-icon="1"
          @click="activeStep = 0"
          :variant="activeStep === 0 ? 'secondary' : undefined" />
      </div>
      <div class="tw-w-1/3 tw-h-0.5 tw-bg-primary-600"></div>
      <div>
        <RoundIconButton
          v-if="useUserConfigStore().userData.remoteControlTOTP"
          fa-icon="check"
          variant="statusGreen"
          disabled />
        <RoundIconButton
          v-else
          fa-icon="2"
          @click="activeStep = 1"
          :variant="activeStep === 1 ? 'secondary' : undefined" />
      </div>
    </div>

    <div
      v-if="
        useUserConfigStore().userData.remoteControlTOTP && useUserConfigStore().userData.remoteControlSLA && !useRemoteControlStore().isRCModalOpen
      "
      class="tw-bg-white tw-p-8 tw-w-full tw-mx-auto tw-flex tw-flex-col tw-items-center tw-justify-center">
      <font-awesome-icon
        icon="check"
        class="tw-text-green-600 tw-text-6xl" />
      <p
        class="tw-py-8 tw-text-center tw-font-semibold tw-text-lg"
        v-html="t('rc.message_setup_success')"></p>
      <div v-if="useRemoteControlStore().isSlaOtpStepperModalOpen">
        <BaseButton
          :text="t('rc.redirect_label_stay_on_page')"
          @click="useRemoteControlStore().isSlaOtpStepperModalOpen = false" />
      </div>
      <div v-else>
        <RouterLink to="/device-list">
          <BaseButton :text="t('rc.redirect_label_go_to_device_list')" />
        </RouterLink>
      </div>
    </div>
    <div
      v-else
      class="tw-bg-white tw-p-8 tw-w-full tw-mx-auto">
      <SLADisplayer
        v-if="activeStep === 0"
        :isRcSLA="true"
        @accept="handleSLA" />
      <OTPSetup
        v-if="activeStep === 1"
        @accept="handleOTP" />
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseButton from "@/components/library/BaseButton/BaseButton.vue";
import OTPSetup from "@/components/library/RemoteControl/OTPSetup/OTPSetup.vue";
import SLADisplayer from "@/components/library/RemoteControl/SLADisplayer/SLADisplayer.vue";
import RoundIconButton from "@/components/library/RoundIconButton/RoundIconButton.vue";
import { onMounted, ref } from "vue";
import { RouterLink } from "vue-router";
import { useTranslation } from "i18next-vue";
import { useRemoteControlStore } from "@/storeModules/remoteControl/remoteControlStore";
import { useUserConfigStore } from "@/storeModules/userConfigs";

const { t } = useTranslation();

const props = defineProps({
  skipSLA: {
    type: Boolean,
    default: false,
  },
});

const activeStep = ref(0);

const handleOTP = () => {
  if (!useUserConfigStore().userData.remoteControlSLA) {
    activeStep.value = 0;
  }
};

const handleSLA = () => {
  if (!useUserConfigStore().userData.remoteControlTOTP) {
    activeStep.value = 1;
  }
};

onMounted(() => {
  if (props.skipSLA) {
    activeStep.value = 1;
    return;
  }
  if (useUserConfigStore().userData.remoteControlSLA) {
    activeStep.value = 1;
  }
});
</script>
